export default __webpack_public_path__ + "static/media/icon-msg-bad.a9f111e9.svg";